import { render, staticRenderFns } from "./LayoutNotification.vue?vue&type=template&id=83510b24&scoped=true&"
import script from "./LayoutNotification.vue?vue&type=script&lang=js&"
export * from "./LayoutNotification.vue?vue&type=script&lang=js&"
import style0 from "./LayoutNotification.vue?vue&type=style&index=0&id=83510b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83510b24",
  null
  
)

export default component.exports